<rx-icon class="custom-close" name="close" (click)="close()"></rx-icon>
<rx-tabs [(selected)]="selectedTab">
  <rx-tab>Create Form (Editable)</rx-tab>
  <rx-tab>Upload Existing Form (PDF)</rx-tab>
  <rx-tab>&nbsp;</rx-tab>
</rx-tabs>
<div *ngIf="selectedTab === 0" class="editable-form">
  <form [formGroup]="formGroup">
    <div class="form-field">
      <rx-input
        labelText="Form Title"
        placeholder="Form Title"
        formControlName="name"
        [keepPlaceholder]="true"
        [hasInlineInfo]="true"
        [maxLength]="50"
        rxFormControlError
      ></rx-input>
    </div>
    <div class="form-field-hint"><a>Editable Form</a> uses a standartizised design for digital completion.</div>
  </form>
</div>
<div *ngIf="selectedTab === 1" class="branded-form">
  <div class="drop-zone">
    <div class="flex" *ngIf="!isBusy && !formAssembled">
      <div class="drop-zone-info">
        <rx-icon name="icon-upload-device"></rx-icon>
        <div>Drag your form file here or <a href="">upload</a> it from your device</div>
        <div class="grayout">Please upload high quality <strong>PDF</strong> form.</div>
      </div>
      <input
        type="file"
        (change)="selectFile($event)"
        name="file1"
        id="file1"
        class="inputfile"
        accept="application/pdf"
      />
    </div>
    <div class="flex" *ngIf="!isBusy && formAssembled">
      <div class="drop-zone-info">Form successfully converted, click Create button to save changes.</div>
    </div>
    <div class="flex" *ngIf="isBusy"><rx-icon name="icon-spinner"></rx-icon>&nbsp; Please Wait...</div>
  </div>
  <div class="form-field-hint"><a>PDF Form</a> is a graphic rich form that can be filled and completed.</div>
</div>
